import { FC } from "react";
import style from "./CustomBadge.module.scss";
import Typhography from "../Typhography/Typhography";
import classNames from "classnames";
export const CustomBadge: FC<{
  label: string;
  className?: string;
  color?: "lightblue" | "lightgreen" | "light-blue-dust" | "lightred" | "purple";
}> = ({ label, className, color = "lightblue" }) => {
  return (
    <div className={classNames(style.container, style[color], className)}>
      <Typhography size="bold-12" className={`label-${color}`}>
        {label}
      </Typhography>
    </div>
  );
};
